package com.example.event_management_system.data.models

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String = "",
    val email: String = "",
    val displayName: String = "",
    val phone: String? = null,
    val role: UserRole = UserRole.STAFF,
    val locationIds: List<String> = emptyList(),
    val primaryLocationId: String? = null,
    val senderEmail: String? = null,
    val replyToEmail: String? = null,
    val ccEmails: List<String> = emptyList(),
    val bccEmails: List<String> = emptyList(),
    @kotlinx.serialization.Serializable(with = LongAsDoubleSerializer::class)
    val createdAt: Long = 0L,
    @kotlinx.serialization.Serializable(with = LongAsDoubleSerializer::class)
    val lastLogin: Long = 0L,
    val isActive: Boolean = true
)
